import { render, staticRenderFns } from "./walletLine.vue?vue&type=template&id=3cfba54a&scoped=true"
import script from "./walletLine.vue?vue&type=script&lang=js"
export * from "./walletLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfba54a",
  null
  
)

export default component.exports